import React, { Component } from 'react';
import styled from 'styled-components';
import Colors from '../Styles/Colors';
import NavigationHeader from './NavigationHeader';

const Container = styled.div`
    background: ${Colors.black};
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    text-align: center;
    padding: ${props => (props.fullWidth) ? 0 : '0 13px'};
    height: 100vh;
    overflow: hidden;
`;
const ContentContainerMain = styled.div`
    background-color: ${Colors.black};
    border: 1px solid ${Colors.black};
    width: 100%;
    flex: 1 1 100%;
    padding: 14px 14px 82px;
    overflow-x: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    text-align: left;
`;
const ContentContainerFullWidth = styled.div`
    background-color: ${Colors.black};
    width: 100%;
    flex: 1 1 100%;
    padding: 14px 14px 120px;
    overflow-x: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    text-align: left;
`;
const ContentContainerNoWrapper = styled.div`
    width: 100%;
    flex: 1 1 100%;
    padding: 14px 14px 82px;
    overflow-x: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    text-align: left;
`;

class ContentLandingPageWrapper extends Component {
    componentDidMount = () => {};

    render() {
        let ContentContainer = ContentContainerMain;
        if (this.props.contentWrapper === false) {
            ContentContainer = ContentContainerNoWrapper;
        } else if (this.props.fullWidth === true) {
            ContentContainer = ContentContainerFullWidth;
        }
        return (
            <Container fullWidth={this.props.fullWidth}>
                { this.props.header !== false &&
                    <NavigationHeader title={this.props.headerTitle} subtitle={this.props.headerSubtitle} />
                }
                <ContentContainer>
                    { this.props.children }
                </ContentContainer>
            </Container>      
        );
    }
}

export default ContentLandingPageWrapper;
